export const REDUCER_KEY_RS_BREADCRUMBS = 'rsBreadcrumbs';
export const RS_BREADCRUMBS_LOCAL_STORAGE_KEY = 'rs-breadcrumbs';

export const FETCH_PROJECT_BREADCRUMB_INFO = 'rs/breadcrumbs/FETCH_PROJECT_BREADCRUMB_INFO';
export const FETCH_PROJECT_BREADCRUMB_INFO_SUCCESS = 'rs/breadcrumbs/FETCH_PROJECT_BREADCRUMB_INFO_SUCCESS';
export const FETCH_PROJECT_BREADCRUMB_INFO_FAILURE = 'rs/breadcrumbs/FETCH_PROJECT_BREADCRUMB_INFO_FAILURE';
export const FETCH_PROJECTS_COUNT_SUCCESS = 'rs/breadcrumbs/FETCH_PROJECTS_COUNT_SUCCESS';
export const CLEAR_PROJECTS_COUNT = 'rs/breadcrumbs/CLEAR_PROJECTS_COUNT';
